export enum BadgeStatus {
  NotCompleted,
  Completed,
}
